var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsBenefitsBgShapeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 234,
    viewBox: "0 0 266 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2708_8518",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 266,
    height: 234
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266 233.072H0V-0.000473022H266V233.072Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2708_8518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.973 -89.6133C58.4277 -101.879 6.70106 -70.0341 -5.56433 -18.4892C-13.5671 15.1498 -2.42227 51.2948 23.1079 74.6218C38.2428 88.4469 55.1266 92.4596 73.9184 99.2889C130.869 120.004 195.611 156.717 206.627 222.23C209.867 241.484 230.688 207.118 233.732 201.917C294.075 98.8422 249.283 -36.539 137.403 -80.9594C128.484 -84.5027 119.308 -87.3874 109.973 -89.6133Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.692 -82.7534C61.4937 -94.4585 12.1217 -64.0677 0.41658 -14.8698C-7.22279 17.2398 3.41479 51.7343 27.779 73.9937C42.2249 87.1904 58.3441 91.0214 76.2727 97.5403C130.627 117.309 192.423 152.356 202.939 214.879C206.028 233.255 225.903 200.456 228.81 195.489C286.405 97.1087 243.657 -32.1019 136.873 -74.5008C128.363 -77.8775 119.603 -80.6411 110.692 -82.761V-82.7534Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.41 -75.8943C64.5596 -87.0392 17.5423 -58.1019 6.39742 -11.2511C-0.878535 19.329 9.25176 52.1806 32.4576 73.3725C46.2145 85.9407 61.5614 89.5825 78.6345 95.7985C130.391 114.621 189.235 147.995 199.252 207.535C202.197 225.032 221.125 193.8 223.889 189.068C278.735 95.3821 238.024 -27.658 136.335 -68.0354C128.226 -71.2531 119.883 -73.8804 111.403 -75.9019L111.41 -75.8943Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.13 -69.0274C67.6266 -79.6195 22.9715 -52.1284 12.3793 -7.62472C5.46677 21.4185 15.0898 52.6271 37.1297 72.759C50.1976 84.6913 64.7722 88.1589 80.9973 94.0569C130.165 111.94 186.056 143.641 195.573 200.198C198.367 216.817 216.348 187.153 218.975 182.663C271.073 93.6707 232.399 -23.2063 135.813 -61.5546C128.113 -64.6134 120.186 -67.1043 112.13 -69.0198V-69.0274Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.857 -62.1673C70.7003 -72.1991 28.3998 -46.1617 18.3679 -4.00508C11.8188 23.5088 20.9346 53.0668 41.816 72.1388C54.195 83.4426 68.0049 86.7285 83.3669 92.3161C129.938 109.253 182.883 139.28 191.901 192.854C194.55 208.595 211.578 180.498 214.069 176.243C263.418 91.9451 226.789 -18.7614 135.29 -55.0882C127.999 -57.988 120.489 -60.3426 112.857 -62.1597V-62.1673Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.576 -55.3081C73.7738 -64.7797 33.8205 -40.1884 24.3489 -0.386421C18.1632 25.5905 26.7717 53.5056 46.4871 71.5175C58.1771 82.193 71.2148 85.2896 85.7212 90.5668C129.695 106.565 179.695 134.919 188.205 185.51C190.704 200.372 206.785 173.843 209.14 169.822C255.741 90.226 221.148 -14.325 134.753 -48.6227C127.863 -51.3559 120.776 -53.5894 113.568 -55.3005L113.576 -55.3081Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.296 -48.4482C76.8407 -57.3596 39.2495 -34.2219 30.3306 3.23298C24.5159 27.6805 32.6095 53.9451 51.1666 70.8971C62.1676 80.9441 74.433 83.859 88.0915 88.8257C129.476 103.877 176.523 130.558 184.534 178.166C186.888 192.158 202.023 167.18 204.234 163.402C248.087 88.5002 215.538 -9.8804 134.231 -42.1566C127.75 -44.7308 121.079 -46.828 114.296 -48.4407V-48.4482Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.015 -41.5818C79.907 -49.9328 44.6705 -28.2488 36.3195 6.85897C30.8682 29.7771 38.4621 54.3911 55.8457 70.2756C66.1577 79.6942 77.6584 82.4274 90.4538 87.0761C129.241 101.181 173.344 126.197 180.847 170.814C183.05 183.927 197.238 160.517 199.313 156.974C240.417 86.7657 209.905 -5.44427 133.701 -35.7065C127.628 -38.1217 121.375 -40.0827 115.015 -41.5969V-41.5818Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.734 -34.7215C82.9729 -42.5198 50.0911 -22.2819 42.3003 10.4788C37.2124 31.8599 44.2991 54.831 60.5243 69.6555C70.1397 78.4457 80.8757 80.9896 92.8155 85.3355C129.014 98.5019 170.163 121.836 177.167 163.478C179.226 175.713 192.46 153.87 194.399 150.569C232.755 85.0554 204.287 -0.991639 133.178 -29.2248C127.507 -31.4734 121.677 -33.3132 115.741 -34.7215H115.734Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.461 -27.8621C86.0477 -35.1002 55.5281 -16.3084 48.29 14.1052C43.5656 33.957 50.145 55.2852 65.2041 69.0421C74.1306 77.1963 84.0943 79.5661 95.1862 83.6016C128.787 95.8215 166.992 117.49 173.488 156.141C175.396 167.498 187.684 147.223 189.486 144.156C225.086 83.3366 198.662 3.4601 132.649 -22.7515C127.387 -24.8412 121.973 -26.5447 116.461 -27.8545V-27.8621Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBenefitsBgShapeGreen);
export default __webpack_public_path__ + "static/media/products_benefits_bg_shape_green.e0a3618c6edb9bb7d65c79ccc9f61fc2.svg";
export { ForwardRef as ReactComponent };